import "../css/AboutUs.css";
import "../css/SectionHeaders.css";
import { useState } from "react";

const AboutUs = ({ scrollToSection }) => {
  return (
    <div className="about-us-container">
      <div className="section-header" id="about-us">
        <h2>About Us</h2>
      </div>
      <div className="welcome-message-container">
        <p className="welcome-message">
          We are a Brighton based team of roofers with over 10 years of
          experience operating throughout East Sussex. From replacement
          guttering to full re-roofs we take on all roofing projects from start
          to finish. Don't hesitate to get in-touch for a free no obligation
          quote, we are also on call 24/7 to attend to emergency storm damage.
        </p>
      </div>
      
      <div className="about-features">
        <div className="feature-item">
          <div className="feature-text">
            <div className="feature-header">
              <div className="feature-icon">✓</div>
              <h3>Experienced Team</h3>
            </div>
            <p>Over 10 years of professional roofing experience in Brighton & Hove</p>
          </div>
        </div>
        
        <div className="feature-item">
          <div className="feature-text">
            <div className="feature-header">
              <div className="feature-icon">✓</div>
              <h3>Quality Workmanship</h3>
            </div>
            <p>Attention to detail and high-quality materials for lasting results</p>
          </div>
        </div>
        
        <div className="feature-item">
          <div className="feature-text">
            <div className="feature-header">
              <div className="feature-icon">✓</div>
              <h3>24/7 Emergency Service</h3>
            </div>
            <p>Available around the clock for emergency storm damage repairs</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
